import "../namespace.js";

window.Sparkle ??= {};
window.Sparkle.Embed ??= {};

Sparkle.Embed.Utilities = Sparkle.Embed.Utilities || {};
